<div class="notifications-container" [@appearDisappearAnim]="notifications.length">
  <div *ngFor="let notification of notifications" class="notification">
    <ng-template [cdkPortalOutlet]="notification"></ng-template>
  </div>
</div>
